/** Human-facing bill title: custom label or default "Cuenta #id". */
export function displayTitle(bill) {
  if (!bill || bill.id == null) return '';
  const trimmed = bill.name != null ? String(bill.name).trim() : '';
  return trimmed ? trimmed : `Cuenta #${bill.id}`;
}

/** True when the bill has a non-empty custom name (after trim). */
export function hasBillLabel(bill) {
  if (!bill || bill.name == null) return false;
  return String(bill.name).trim().length > 0;
}
